import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SETTINGS_WHAT_CANT_BE_ATTENDED } from "api/Service";

export const WHAT_CANT_BE_ATTENDED_QUERY_KEY = "whatCantBeAttended";

export const useWhatCantBeAttended = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [WHAT_CANT_BE_ATTENDED_QUERY_KEY, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${PRACTICE_SETTINGS_WHAT_CANT_BE_ATTENDED}`
      );

      return Array.isArray(response.data) ? response.data : [];
    },
    enabled: !!tenantVal,
    staleTime: 5 * 60 * 1000,
  });
};
